import { useCallback } from 'react';
import { ACTION_TYPES, useBaseLayoutDispatch, useBaseLayoutState } from './base-layout-context';
import { DefaultDialogProps } from '../default-dialog';
import { DefaultMessageProps } from '../default-message';
import { DefaultBackdropProps } from '../default-backdrop';

export function useBaseLayoutController() {
    const dispatch = useBaseLayoutDispatch();
    const state = useBaseLayoutState();

    const showDialog = useCallback((props: DefaultDialogProps) => {
        dispatch({
            type: ACTION_TYPES.SHOW_DIALOG,
            payload: {
                ...props,
                onClose: () => {
                    dispatch({ type: ACTION_TYPES.HIDE_DIALOG });
                    if (props.onClose) {
                        props.onClose();
                    }
                },
            },
        });
    }, [dispatch]);

    const hideDialog = useCallback(() => {
        dispatch({ type: ACTION_TYPES.HIDE_DIALOG });
    }, [dispatch]);

    const showMessage = useCallback((props: DefaultMessageProps) => {
        dispatch({
            type: ACTION_TYPES.SHOW_MESSAGE,
            payload: {
                ...props,
                onClose: () => {
                    dispatch({ type: ACTION_TYPES.HIDE_MESSAGE });
                    if (props.onClose) {
                        props.onClose();
                    }
                },
            },
        });
    }, [dispatch]);

    const hideMessage = useCallback(() => {
        dispatch({ type: ACTION_TYPES.HIDE_MESSAGE });
    }, [dispatch]);

    const showLoading = useCallback((props: DefaultBackdropProps) => {
        dispatch({
            type: ACTION_TYPES.SHOW_LOADING,
            payload: props,
        });
    }, [dispatch]);

    const hideLoading = useCallback(() => {
        dispatch({ type: ACTION_TYPES.HIDE_LOADING });
    }, [dispatch]);

    return {
        // State
        dialogProps: state.dialogProps,
        messageProps: state.messageProps,
        loadingProps: state.loadingProps,

        // Actions
        showDialog,
        hideDialog,
        showMessage,
        hideMessage,
        showLoading,
        hideLoading,
    };
}
